var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTimePeriodIcon = function SvgTimePeriodIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M19.167 6.7H.833c-.46 0-.833.373-.833.833V17.5C0 18.878 1.122 20 2.5 20h15c1.378 0 2.5-1.122 2.5-2.5V7.533c0-.46-.373-.833-.833-.833z",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M17.5 2.5h-15C1.12 2.5 0 3.62 0 5v2.533h20V5c0-1.38-1.12-2.5-2.5-2.5z",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A7D9FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.68 0H.846C.386 0 .013.373.013.833v3.334c0 .46.373.833.833.833h.834c.46 0 .833-.373.833-.833V.833C2.513.373 2.14 0 1.68 0zM12.513 0h-.833c-.46 0-.834.373-.834.833v3.334c0 .46.374.833.834.833h.833c.46 0 .833-.373.833-.833V.833c0-.46-.373-.833-.833-.833z",
    transform: "translate(6 6) translate(3.32)"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimePeriodIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time_period_icon.70fb71e3.svg";
export { ForwardRef as ReactComponent };